import { useAtomValue } from 'jotai'
import { atomWithReset } from 'jotai/utils'

/** 比較優位の対象ブランド（key・名前解決用に brandId を保持する） */
export type ComparisonBrand = {
  id: number
  name: string
}

export type NpiDriverAnswerData = {
  option: number
  text: string
  npiRatioByNineSegment: Record<number, number>
  npiRatioByFiveSegment: Record<number, number>
  importanceRatioByNineSegment: Record<number, number>
  importanceRatioByFiveSegment: Record<number, number>
  comparisonAdvantageBrands: ComparisonBrand[]
  podScore: number | null
  hasTextMismatch: boolean
}

export const npiDriverDataAtom = atomWithReset<NpiDriverAnswerData[] | null>(
  null,
)

export const useNpiDriverTableData = (): NpiDriverAnswerData[] => {
  const data = useAtomValue(npiDriverDataAtom)

  return data ?? []
}
